module.exports = __webpack_public_path__ + "img/digital-footprint.c1feba8f.svg";